/** Global single-key shortcuts. Ignored while typing. Pages listen for the custom events. */
export const FOCUS_SEARCH = 'lsc:focus-search';
export const LOG_TICKET = 'lsc:log-ticket';

export function isTyping(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable;
}

export function emit(name: string): void {
  window.dispatchEvent(new CustomEvent(name));
}
